export default __webpack_public_path__ + "static/char-s-40-zh-Hant-3d6be6517ad7bdc73be1b26ff0e07242.png";